import { mapState } from 'vuex'

/*
 * Title and og:title for the artist sub-pages: "<nickname> - <section>".
 *
 * The section label comes from the page's own <i18n> block under `pageTitle`,
 * so both locales render server-side. og:title mirrors the visible title, with
 * the site template applied, so a shared link names the section instead of
 * falling back to the artist-level default from pages/_id.vue.
 *
 * A page using this mixin must not define its own head(); Vue would let the
 * page's head() replace this one rather than merge it.
 */
export default {
  computed: {
    ...mapState(['artist'])
  },

  head() {
    const title = `${this.artist.nickname} - ${this.$t('pageTitle')}`
    return {
      title,
      meta: [
        {
          hid: 'og:title',
          property: 'og:title',
          content: `getnext.to - ${title}`
        }
      ]
    }
  }
}
